export default {
  ERROR: 'essayTaskPopupError'
};
